<template>
    <el-row class="tac" style="height: 100vh">
        <el-col :span="2" style="
        max-width: 80px;
        min-width: 80px;
        height: 100%;
        background: #f4f6f7;
      ">
            <div class="img-box">
                <img :src="logoSrc" class="img-responsive" />
            </div>

            <el-menu :default-active="$route.path" class="el-menu-vertical-demo" router
                style="height: 100%; width: 72px; border: none">
                <el-menu-item :index="`/nav/${menu.path}`" v-for="menu in menus" :key="menu.id">
                    <template slot="title">
                        <div class="sliderName">{{ menu.authName }}</div>
                    </template>
                </el-menu-item>
            </el-menu>


            <router-link to="/nav/system-set" style="
                position: absolute;
                left: 26px;
                bottom: 30px;
                font-size: 20px;
                color: #000;
            ">
                <i class="el-icon-setting"></i>
            </router-link>
        </el-col>
        <el-main>
            <keep-alive>
                <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
        </el-main>
    </el-row>
    <!-- <div class="sliderbar">
    <div class="oLeft">
      <el-menu :default-active="$route.path" class="el-menu-vertical-demo" router style="height: 100%">
        <el-menu-item :index="`/nav/${menu.path}`" v-for="menu in menus" :key="menu.id">
          <template slot="title">
            <span>{{ menu.authName }}</span>
          </template>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="oRight">
      <router-view />
    </div>
  </div> -->
</template>
<script>
import { getColorConfig, getLogo } from "@/api/system-set";
export default {
    data() {
        return {
            logoSrc: "",
            checkedColor: "#00bf8a", // 选中时的颜色,主体颜色
            menus: [
                {
                    authName: "收银",
                    path: "cashier",
                    index: "1",
                    icon: "el-icon-s-finance",
                },
                {
                    authName: "商品",
                    path: "commodity",
                    index: "2",
                    icon: "el-icon-s-finance",
                },
                {
                    authName: "订单",
                    path: "order",
                    index: "3",
                    icon: "el-icon-s-finance",
                },
                {
                    authName: "打印",
                    path: "printd",
                    index: "7",
                    icon: "el-icon-s-finance",
                },
                {
                    authName: "会员",
                    path: "member/index",
                    index: "4",
                    icon: "el-icon-s-finance",
                },
                {
                    authName: "交班",
                    path: "shift",
                    index: "5",
                    icon: "el-icon-s-finance",
                },
                {
                    authName: "报表",
                    path: "report",
                    index: "6",
                    icon: "el-icon-s-finance",
                },
            ],
        };
    },
    created() {
        console.log(this.$route.path);
        this.getColorConfig();
        this.doGetLogo();
    },
    watch: {
        checkedColor: function (val) {
            let hex = val.replace("#", "");
            const r = parseInt(hex.substr(0, 2), 16);
            const g = parseInt(hex.substr(2, 2), 16);
            const b = parseInt(hex.substr(4, 2), 16);
            let style = document.createElement("style");
            style.innerHTML = `.is-active {
        background-color: rgb(${r}, ${g}, ${b}, 0.1) !important;
        background: rgb(${r}, ${g}, ${b}, 0.1) !important;
        color: ${val} !important;
      }
      .is-active::after{background: ${val} !important;}
      .el-menu-item:hover {
        background: rgb(${r}, ${g}, ${b}, 0.1) !important;
      }`;
            document.head.appendChild(style);
        },
    },
    methods: {
        async doGetLogo() {
            const res = await getLogo();
            if (res.code === 200) {
                res.data.forEach((item) => {
                    if (item.name == "desk_logo") {
                        this.logoSrc = item.value;
                    }
                });
            } else {
                this.$message.error(res.msg);
            }
        },
        // 获取颜色设置
        async getColorConfig() {
            const res = await getColorConfig();
            if (res.code === 200) {
                res.data.forEach((item) => {
                    switch (item.name) {
                        case "desk_color":
                            // 收银台主体颜色
                            this.checkedColor = item.value;
                            break;
                        default:
                            break;
                    }
                });
            } else {
                this.$message.error(res.msg);
            }
        },
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        },
    },
};
</script>
<style scoped lang="less">
/deep/.el-main {
    padding: 0;
    min-height: 100vh;
    // position: relative;
}

/deep/ .el-menu-item {
    height: 72px;
    line-height: 72px;
    padding: 0 !important;
    text-align: center;
    font-size: 16px;
}

/deep/.is-active {
    position: relative;
    font-weight: bold;
    background: rgba(229, 248, 243);
    color: @desk-font-color;
}

/deep/.is-active::after {
    content: "";
    width: 3px;
    height: 72px;
    background: @desk-color;
    position: absolute;
    right: 0;
    top: 0;
}

/deep/.el-menu-item:hover {
    background: rgba(229, 248, 243);
}

.img-box {
    padding: 10px;
    width: calc(100% - 20px);
    height: 50px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
}

.img-responsive {
    width: 100%;
    height: auto;
    border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation.vue